import { Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { EmptyFilesUpload } from './EmptyFilesUpload';
import { StyledEmptyData } from './Styles';

export const EmptyData = () => {
  const { t } = useTranslation();

  return (
    <StyledEmptyData
      flexDirection={'column'}
      justifyContent="center"
      alignItems="center"
      rowGap="1.2"
    >
      <EmptyFilesUpload />
      <Label fontSize="14" semibold>
        {t('There is no information')}
      </Label>
    </StyledEmptyData>
  );
};
